<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse"/>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <div v-if="userInfo&&userInfo.type=='USER'" class="btn-logout" :class="{ collapse: isCollapse }">
      <a href="javascript:;;" @click="logout" class="chrome-box">
        <svg-icon icon-class="logout" class="card-panel-icon"/>
        <span>Logout</span>
      </a>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Logo from "./Logo.vue";
import SidebarItem from "./SidebarItem.vue";
import variables from "@//styles/variables.scss";

export default {
  components: {SidebarItem, Logo},
  data() {
    return {
      menuCollapsed: false,
      sidebarReady: false,
    }
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar", "userInfo"]),
    activeMenu() {
      const route = this.$route;
      const {meta, path} = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return this.menuCollapsed;
    },
  },
  watch: {
    "sidebar.opened": {
      immediate: true,
      handler(opened) {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
        const mobile = this.$store.state.app.device === "mobile"
        clearTimeout(this._collapseTimer)
        if (!this.sidebarReady || reduce || mobile || this.sidebar.withoutAnimation) {
          this.menuCollapsed = !opened
          return
        }
        if (opened) {
          this.menuCollapsed = false
          return
        }
        this._collapseTimer = setTimeout(() => {
          if (!this.sidebar.opened) {
            this.menuCollapsed = true
          }
        }, 280)
      },
    },
  },
  mounted() {
    this.sidebarReady = true
    this.$el.addEventListener("transitionend", this.onSidebarTransitionEnd)
  },
  beforeDestroy() {
    clearTimeout(this._collapseTimer)
    this.$el.removeEventListener("transitionend", this.onSidebarTransitionEnd)
  },
  methods: {
    onSidebarTransitionEnd(event) {
      if (event.target !== this.$el || event.propertyName !== "width") {
        return
      }
      if (!this.sidebar.opened) {
        clearTimeout(this._collapseTimer)
        this.menuCollapsed = true
      }
    },
    logout() {
      this.$store.dispatch("user/logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@//styles/variables.scss";

.btn-logout {
  position: absolute;
  bottom: 10px;
  left: 8px;
  right: 8px;
  height: 44px;
  color: #ffff;
  font-weight: $menuFontWeight;
  font-size: 14px;
  z-index: 10;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  .chrome-box {
    border-radius: 8px;
    width: 100% !important;
    margin: 0 auto;
    padding-left: 16px;
    padding-right: 16px;
    height: 44px;
    line-height: 44px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    cursor: pointer;
    transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
    box-shadow: 0 2px 8px rgba(237, 28, 36, 0.25);
    background: $main-color !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(237, 28, 36, 0.35);
      background: $main-color-dark !important;
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 6px rgba(237, 28, 36, 0.25);
    }

    .card-panel-icon {
      font-size: 18px;
      transition: transform 0.3s ease;
    }

    &:hover .card-panel-icon {
      transform: rotate(-15deg);
    }

    span {
      font-size: 14px;
      font-weight: $menuFontWeight;
    }
  }
}

.btn-logout.collapse {
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .chrome-box {
    width: 40px !important;
    height: 40px;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 0;
    
    span {
      display: none;
    }
    
    .card-panel-icon {
      margin: 0 !important;
      padding: 0 !important;
      font-size: 20px !important;
      line-height: 1;
      
      ::v-deep svg {
        width: 20px !important;
        height: 20px !important;
        margin: 0 !important;
        vertical-align: middle !important;
      }
    }
  }
}
</style>
